import React from 'react';
import CaptionsComponent from '../components/Captions';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';













function Captions(props) {
  return (
    <AddonsContextConsumer>
      {({ constants: { CAPTIONS: getCaptions }, actions: { getCurrencySymbol } }) =>
      <CaptionsComponent
        {...props}
        // $FlowFixMe Cannot call CAPTIONS because undefined [1] is not a function.
        BURN_IN_CAPTIONS={getCaptions('BURN_IN_CAPTIONS')}
        // $FlowFixMe Cannot call CAPTIONS because undefined [1] is not a function.
        SRT_CAPTIONS={getCaptions('SRT_CAPTIONS')}
        getCurrencySymbol={getCurrencySymbol} />}


    </AddonsContextConsumer>);

}

export default Captions;